/**
 * 헤더 메뉴 정의와 활성 판정.
 *
 * react-router 의 NavLink 는 isActive 를 경로로만 계산해서
 * /products 와 /products?sortBy=popular 를 구분하지 못한다.
 * 같은 경로에 쿼리로만 갈리는 메뉴가 있어 직접 판정한다.
 */
export interface NavItem {
  label: string;
  to: string;
  /** 이 경로(및 하위 경로)일 때만 후보가 된다. */
  path: string;
  /** 같은 경로를 쓰는 메뉴를 가르는 쿼리 파라미터. */
  param?: { key: string; value: string };
  /** 해당 쿼리 파라미터가 아예 없을 때 기본으로 선택되는 메뉴. */
  defaultForPath?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { label: '전체 상품', to: '/products', path: '/products' },
  {
    label: '베스트',
    to: '/products?sortBy=popular',
    path: '/products',
    param: { key: 'sortBy', value: 'popular' },
  },
  {
    label: '상품문의',
    to: '/boards?boardType=QNA',
    path: '/boards',
    param: { key: 'boardType', value: 'QNA' },
    // 게시판 목록은 boardType 이 없으면 QNA 를 보여 준다.
    defaultForPath: true,
  },
  {
    label: '고객의 소리',
    to: '/boards?boardType=VOC',
    path: '/boards',
    param: { key: 'boardType', value: 'VOC' },
  },
];

/** 경로가 맞고 쿼리 조건까지 맞아야 활성이다. */
export function isNavActive(item: NavItem, pathname: string, query: URLSearchParams): boolean {
  if (pathname !== item.path && !pathname.startsWith(`${item.path}/`)) {
    return false;
  }

  if (item.param) {
    const current = query.get(item.param.key);
    if (current === item.param.value) return true;
    // 파라미터가 없으면 그 경로의 기본 메뉴가 선택된 것으로 본다.
    return Boolean(item.defaultForPath) && current === null;
  }

  // 조건이 없는 메뉴(전체 상품)는 같은 경로의 다른 메뉴가 활성이면 비켜 준다.
  return !NAV_ITEMS.some(
    (other) => other.path === item.path && other.param && query.get(other.param.key) === other.param.value,
  );
}
